// extracted by mini-css-extract-plugin
module.exports = {"game-header":"GameHeader_game-header__6DrxL","metadata-pill":"GameHeader_metadata-pill__EeQNO","headline":"GameHeader_headline__fTwmz"};